module.exports = __webpack_public_path__ + "img/p80.ef28ef45.png";